/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum SalePricesWeekEnum {
    WEEKS_1 = 1,
    WEEKS_52 = 52,
    WEEKS_78 = 78,
    WEEKS_104 = 104,
    WEEKS_156 = 156,
}

export enum VehicleSortTypeEnum {
    SALES_RANKING = "salesRanking",
    PROMOTION = "promotion",
    HIGHER_PRICE = "higherPrice",
    LOWER_PRICE = "lowerPrice",
    HIGHER_MARKET_PRICE = "higherMarketPrice",
    LOWER_MARKET_PRICE = "lowerMarketPrice",
    HIGHER_CC = "higherCC",
    LOWER_CC = "lowerCC",
    HIGHER_KM = "higherKM",
    LOWER_KM = "lowerKM",
}

export enum VehicleStatusEnum {
    AVAILABLE = "available",
    DELIVERED = "delivered",
    ASIDE = "aside",
    LOST = "lost",
    IN_RECOVERY = "inRecovery",
    RECOVERED = "recovered",
    DRAFT = "draft",
}

export enum VehicleColorEnum {
    pink = "pink",
    purple = "purple",
    blue = "blue",
    orange = "orange",
    green = "green",
    white = "white",
    gray = "gray",
    red = "red",
    black = "black",
    yellow = "yellow",
    graphite = "graphite",
}

export const vehicleColorValues: Record<VehicleColorEnum, string> = {
    [VehicleColorEnum.pink]: "rosada",
    [VehicleColorEnum.purple]: "morada",
    [VehicleColorEnum.blue]: "azul",
    [VehicleColorEnum.orange]: "naranja",
    [VehicleColorEnum.green]: "verde",
    [VehicleColorEnum.white]: "blanca",
    [VehicleColorEnum.gray]: "gris",
    [VehicleColorEnum.red]: "roja",
    [VehicleColorEnum.black]: "negra",
    [VehicleColorEnum.yellow]: "amarilla",
    [VehicleColorEnum.graphite]: "gris grafito",
};

export enum LenderEnum {
    PayJoy = "PayJoy",
}

export const lenderImages: Record<LenderEnum, { url: string; alt: string; width: number; height: number; }> = {
    [LenderEnum.PayJoy]: {
        url: "https://ik.imagekit.io/ozon/Homepage/Logos/logo_payjoy.jpg",
        alt: `Financiamiento con ${LenderEnum.PayJoy}`,
        width: 70,
        height: 30,
    },
};

export const loanTypeValues: Record<LenderEnum | string, { description: string; bulletPoints: string[]}> = {
    [LenderEnum.PayJoy]: {
        description: "Compra tu moto hoy y paga a tu propio ritmo.",
        bulletPoints: [
            "No necesitas comprobante de ingresos",
            "Comisión de apertura fija de solo $2,000 en cualquier modelo de moto",
            "Liquida tu financiamiento cuando quieras y sin penalizaciones.",
        ]
    },
};
